import { render } from "./iBoxInInRow.vue?vue&type=template&id=2782fd68&scoped=true"
import script from "./iBoxInInRow.vue?vue&type=script&lang=js"
export * from "./iBoxInInRow.vue?vue&type=script&lang=js"

import "./iBoxInInRow.vue?vue&type=style&index=0&id=2782fd68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2782fd68"

export default script